import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ErrorReducerState {
  error: any;
  success: any;
  status: boolean;
}

const initialState: ErrorReducerState = {
  error: null,
  success: null,
  status: false,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    globalReset(state) {
      return initialState;
    },
    request(state) {
      state.error = null;
      state.success = null;
      state.status = true;
    },
    success(state, action: PayloadAction<{ success: any }>) {
      state.success = action.payload.success;
      state.error = null;
      state.status = false;
    },
    error(state, action: PayloadAction<{ error: any }>) {
      state.error = action.payload.error;
      state.success = null;
      state.status = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => /REQUEST/.test(action.type),
        (state) => {
          state.error = null;
          state.success = null;
          state.status = true;
        }
      )
      .addMatcher(
        (action) => /SUCCESS/.test(action.type),
        (state, action: PayloadAction<{ success: any }>) => {
          state.success = action.payload.success;
          state.error = null;
          state.status = false;
        }
      )
      .addMatcher(
        (action) => /ERROR/.test(action.type),
        (state, action: PayloadAction<{ error: any }>) => {
          state.error = action.payload.error;
          state.success = null;
          state.status = false;
        }
      );
  },
});

export const { globalReset, request, success, error } = errorSlice.actions;
export default errorSlice.reducer;
